// @flow
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import { withTranslation } from 'react-i18next';

import { TARIFF_CONSTRUCTOR, TARIFF_BUNDLE } from 'app/common/constants/tariffs';
import { subStop, subPauseResume, subEdit } from 'app/actions/apps/subs';
import { subPay } from 'app/actions/apps/subs/pay';
import { appSubscribe, bundleSubscribe } from 'app/actions/apps/subscribe';
import type { TariffType } from 'app/components/Tariff/Tariff';
import { fetchApps } from 'app/actions/apps/apps';

import createTariffSelector from './selectTariff';


type Props = {
  subId?: string,
  tariff?: TariffType,
  studentId: number,
  service: string,
  close: (e: SyntheticEvent<HTMLElement>) => void,
};

const container = compose(
  withTranslation('tariff'),

  connect(
    () => {
      const tariffSelector = createTariffSelector();
      return (state, props: Props) => ({
        ...tariffSelector(state, props), // sub, tariff, footnotes, footnotesKeys
        stopping: state.apps.opts.stopping,
        pausingResuming: state.apps.opts.pausingResuming,
        subscribing: state.apps.opts.subscribing,
        saving: state.apps.opts.saving,
        paying: state.apps.opts.paying,
      });
    }
  ),


  withState('informersMod', 'setInformers', ({ tariff }) => ({
    lk_enabled: tariff.lk_enabled,
    mobile_enabled: tariff.mobile_enabled,
    sms_enabled: tariff.sms_enabled,
    email_enabled: tariff.email_enabled,
  })),
  withState('isInformersEditing', 'setIsInformersEditing', false),


  withHandlers({
    handlePause: ({ dispatch, subId, sub }) => (e) => {
      e.preventDefault();
      dispatch(subPauseResume(subId, sub.is_paused));
    },

    handleStop: ({ dispatch, subId, close }) => (e) => {
      e.preventDefault();
      dispatch(subStop(subId));
      if (close) {
        close();
      }
    },

    handlePayToday: ({ dispatch, subId }) => async (e) => {
      e.preventDefault();
      const { name } = e.currentTarget;
      await dispatch(subPay(subId, (name === 'lk' || name === 'mobile') ? name : 'all'));
    },

    handleInformerChange: ({ informersMod, setInformers }) => (e) => {
      const { name, checked } = e.currentTarget;
      switch (name) {
        case 'lk': {
          setInformers({ ...informersMod, lk_enabled: checked });
          return;
        }
        case 'mobile': {
          setInformers({ ...informersMod, mobile_enabled: checked });
          return;
        }
        case 'sms': {
          setInformers({ ...informersMod, sms_enabled: checked });
          return;
        }
        case 'email': {
          setInformers({ ...informersMod, email_enabled: checked });
          break;
        }
        default:
      }
    },

    handleSubscribe: ({ dispatch, tariff, studentId, informersMod }) => async (e) => {
      e.preventDefault();
      if (!tariff) return;
      const { id, kind } = tariff;
      let res = false;
      switch (kind) {
        case TARIFF_CONSTRUCTOR: {
          res = await dispatch(appSubscribe(id, studentId, informersMod));
          break;
        }
        case TARIFF_BUNDLE: {
          res = await dispatch(bundleSubscribe(id, studentId));
          break;
        }
        default: {
          res = await dispatch(appSubscribe(id, studentId));
        }
      }
      if (res) {
        await dispatch(fetchApps());
      }
    },

    beginEditInformers: ({ setIsInformersEditing }) => () => {
      setIsInformersEditing(true);
    },

    stopEditInformers: ({ setIsInformersEditing }) => () => {
      setIsInformersEditing(false);
    },

    handleSaveInformers: ({ dispatch, setIsInformersEditing, subId, informersMod, close }) => () => {
      setIsInformersEditing(false);
      dispatch(subEdit(subId, informersMod, close));
    },

  })

);

export default container;
